import { attorneySearchConfig } from "./config/counselSearchConfig";
import AttorneyLikeFieldset from "./components/AttorneyLikeFieldset";

const CounselAttorneyFields = ({ entityId, statesData }) => (
  <AttorneyLikeFieldset
    entityId={entityId}
    prefix="attorney"
    panelName="Opposing Attorney"
    dynamicLabel="Opposing Attorney Full Name"
    searchConfig={attorneySearchConfig}
    statesData={statesData}
  />
);

export default CounselAttorneyFields;
